import styled from '@emotion/styled';
import CancelButton from '@/components/CancelButton';

const CancelChangeButton = styled(CancelButton)({
  marginTop: -12,
  marginBottom: -12,
});

export default CancelChangeButton;
